"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTableCell = exports.MaterialTableCellUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Table_1 = require("material-ui/Table");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => ({
    avatar: {
        border: "none",
        display: "flex",
        height: "45px",
        paddingRight: 0,
        width: "30px"
    },
    center: {
        padding: 0
    },
    header: {
        border: "none",
        fontSize: "10px",
        letterSpacing: "0.5px",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0
    },
    paddingDefault: {
        paddingRight: "24px"
    },
    root: {
        fontSize: "13px"
    }
}));
class MaterialTableCellUnstyled extends react_1.Component {
    render() {
        const { avatar, center, children, classes, header } = this.props;
        const fontWeightClass = header ? "__lighter" : "";
        return (React.createElement(Table_1.TableCell, { className: `material-table-cell${fontWeightClass}`, classes: {
                root: avatar
                    ? classes.avatar
                    : header
                        ? classes.header
                        : classes.root,
                paddingDefault: center ? classes.center : classes.paddingDefault
            } }, children));
    }
}
exports.MaterialTableCellUnstyled = MaterialTableCellUnstyled;
exports.MaterialTableCell = decorate(MaterialTableCellUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/table/table-cell/table-cell.tsx
// module id = 3270
// module chunks = 0